import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
export var FlagSwallowtailOutlineSVG = function FlagSwallowtailOutlineSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M29.8 20.4l-5.52-7.36 5.48-6.39a1.02 1.02 0 00.15-1.07A1 1 0 0029 5H6V4a1 1 0 00-2 0v5H3a1 1 0 000 2h1v5H3a1 1 0 000 2h1v10a1 1 0 002 0v-6h23a1 1 0 00.8-1.6zM6 20v-2h2a1 1 0 000-2H6v-5h2a1 1 0 000-2H6V7h20.83l-4.59 5.35a1 1 0 00-.04 1.25L27 20z"
  }));
};
FlagSwallowtailOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(FlagSwallowtailOutlineSVG);